import { getAssetUrl } from "@/utils/common";
import { Image } from "@shuwen/wenlv-web-activity-library";
import { useXAgentClient } from "@shuwen/wenlv-web-activity-library";
import { useMemo } from "react";

const Title = () => {
  const {deviceInfo} = useXAgentClient();
  const isXihuCitywalk = useMemo(() => {
    return deviceInfo?.exhibitionConfigInfo?.isXihuCitywalk;
  }, [deviceInfo]);
  return (
    <>
      <Image 
        src={getAssetUrl(isXihuCitywalk ? "images/home/title2.png":"images/home/title.png")} 
        style={{
          position: 'absolute',
          left: '64px',
          top: '38px',
          width: '625px',
          zIndex: 11
        }}
        alt="title"
      />
      {
        !isXihuCitywalk&&(
          <Image 
            src={getAssetUrl("images/home/subTitle.png")} 
            style={{
              position: 'absolute',
              left: '2477px',
              top: '72px',
              width: '554px',
              zIndex: 11
            }}
            alt="subTitle"
          />
        )
      }
      
    </>
  );
};

export default Title;